export const ACTION_TYPES = {
  PEF_AVAILAIBLE: "PEF_AVAILAIBLE",
  FETCH_PEF_DATA: "FETCH_PEF_DATA",
  FETCH_LANDING_PAGE_AEM_CONTENT: "FETCH_LANDING_PAGE_AEM_CONTENT",
  FETCH_SINGLE_PEF_DATA: "FETCH_SINGLE_PEF_DATA",
  DASHBOARD_AEM_CONTENT: "DASHBOARD_AEM_CONTENT",
  PEFID: "PEFID",
};
